module.exports = __webpack_public_path__ + "static/threepcblueknitted-08bc2d6a418e2e8bd48c40114a3a98b9.jpeg";